// Sample (comped) wholesale orders are identified by the location's
// Salesforce opportunity. Arabesque's ShippingLocationRecordSync translates
// the two comped opportunity IDs into these readable names and stores them
// as `opportunity` on the Operations record (absent for every other
// location), and CoCToOpsOrders derives `orderType = SAMPLE` from the same
// signal. Keep the raw Salesforce IDs out of the frontend — arabesque owns
// that mapping.
export const SAMPLE_DELIVERY_OPPORTUNITIES = [
  'SalesCompedOrders',
  'MarketingCompedOrders',
];

export function isSampleDeliveryOpportunity(opportunity) {
  return SAMPLE_DELIVERY_OPPORTUNITIES.includes(opportunity);
}
